export default function(d) {
  return d;
}



//////////////////
// WEBPACK FOOTER
// /~/d3-shape/src/identity.js
// module id = o5u5
// module chunks = 0